// src/components/sidebar/useUserUnreadMessages.js
// Nombre de messages de l'admin non lus par le CLIENT, pour le badge de l'icône « Messages ».
import { useCallback, useEffect, useState } from "react";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000/api";

export default function useUserUnreadMessages(intervalMs = 15000) {
  const [unreadMessages, setUnreadMessages] = useState(0);

  const refresh = useCallback(async () => {
    const token = localStorage.getItem("token");
    if (!token) return;
    try {
      const { data } = await axios.get(
        `${API_URL}/messages/user/unread-count`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setUnreadMessages(data.unreadCount || 0);
    } catch (err) {
      /* silencieux : on réessaie au prochain passage */
    }
  }, []);

  useEffect(() => {
    refresh();
    const id = setInterval(refresh, intervalMs);
    return () => clearInterval(id);
  }, [refresh, intervalMs]);

  return [unreadMessages, setUnreadMessages, refresh];
}